var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTokenPocketColorVersion04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 96,
    height: 96,
    rx: 19.2,
    fill: "#2980FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2885_40936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4332 27.6543H41.0015H17.9833C16.8867 27.6543 16 28.541 16 29.6376V37.6876C16 38.7842 16.8867 39.6709 17.9833 39.6709H23.385H25.5316V42.0509V67.5307C25.5316 68.6274 26.4183 69.5141 27.5149 69.5141H35.9616C37.0582 69.5141 37.9449 68.6274 37.9449 67.5307V42.0509V41.8292V39.6709H40.0915H40.9665H41.3982C44.7115 39.6709 47.4065 36.9759 47.4065 33.6626C47.4415 30.3493 44.7465 27.6543 41.4332 27.6543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2539 27.6543C55.0839 27.6543 47.6406 35.0976 47.6406 44.2675C47.6406 44.2894 47.6407 44.3112 47.6408 44.3331V67.4724C47.6408 68.569 48.5274 69.4557 49.6241 69.4557H58.514C59.6107 69.4557 60.4974 68.569 60.4974 67.4724V60.4581L60.5076 60.4605L60.5479 60.4668C60.9912 60.5718 61.4059 60.6473 61.8726 60.7173C62.5259 60.8106 63.2026 60.8689 63.8793 60.8806L64.2538 60.8805C64.5805 60.8805 64.8955 60.8691 65.2105 60.8574C73.9371 60.3558 80.8671 53.1225 80.8671 44.2675C80.8788 35.0976 73.4355 27.6543 64.2539 27.6543ZM65.2105 47.8842C64.9072 47.9659 64.5805 48.0123 64.2538 48.0123C64.164 48.0123 64.0849 48.0111 63.9959 48.0007C62.0802 47.8745 60.5593 46.3046 60.5089 44.3666V44.2676C60.5089 42.2026 62.1889 40.5226 64.2539 40.5226C66.3189 40.5226 67.9989 42.2026 67.9989 44.2676C67.9989 46.0059 66.8205 47.4642 65.2105 47.8842Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2885_40936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.8529,
    height: 42,
    fill: "white",
    transform: "translate(16 27.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenPocketColorVersion04);
export default __webpack_public_path__ + "static/media/Token-Pocket-Color-Version04.5b75dec67c896b17f21b50032a0adf64.svg";
export { ForwardRef as ReactComponent };